/**
 * Return `value` if `min ≤ value ≤ max`. Or `min` if `value < min`. Or `max` if `max < value`.
 *
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
export default (value, min, max) => Math.min(Math.max(min, value), max);
